module.exports = __webpack_public_path__ + "img/rugby-icon-white.bab8c884.png";